import React from 'react'

function Stop ({ className, fill }) {
  return (
    <svg fill={fill} className={className} width='21' height='21' viewBox='0 0 21 21'>
      <rect width='21' height='21' />
    </svg>
  )
}

Stop.defaultProps = {
  className: 'w-full h-full',
  fill: 'currentColor'
}

export default Stop
